import throttle from '@utils/throttle';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setWindowWidth } from '../redux/viewport';

const useViewportSync = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		const syncWidth = () => dispatch(setWindowWidth(window.innerWidth));
		// Only after hydration: the first client render must use the server's user-agent-based width.
		syncWidth();
		const throttleResize = throttle(syncWidth, 500);

		window.addEventListener('resize', throttleResize);

		return () => {
			window.removeEventListener('resize', throttleResize);
		};
	}, [dispatch]);
};

export { useViewportSync };
